import { liteClient as algoliasearch } from "algoliasearch/lite";

const searchClientCache = new Map<string, ReturnType<typeof algoliasearch>>();

export function getSearchClient(applicationId: string, apiKey: string) {
	const key = `${applicationId}:${apiKey}`;
	const cachedClient = searchClientCache.get(key);

	if (cachedClient) {
		return cachedClient;
	}

	const client = algoliasearch(applicationId, apiKey);
	searchClientCache.set(key, client);

	return client;
}
